import { useAuth } from "../components/AuthProvider";
import type { UserRole } from "../types";

const useAuthHasRole = (required: UserRole[]) => {
  const { user } = useAuth();
  const { roles, utilities, utilitiesOverride } = user ?? {};
  const allRoles = [
    ...(roles ?? []),
    ...(utilities ?? []),
    ...(utilitiesOverride ?? []),
  ];
  return !!required.find((r) => allRoles.includes(r));
};

export { useAuthHasRole };
